// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__G1HO8","validationTips":"StatementDescriptor_validationTips__TTPEa"};